// @ts-nocheck
import { IconOffset } from "@toolkit/Framework/Types/Icon";
import * as React from "react";

const HeadphonesLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12 2C6.378 2.11 1.905 6.748 2 12.37V17a4 4 0 1 0 4-4 3.91 3.91 0 0 0-2 .56v-1.19A8.2 8.2 0 0 1 12 4a8.2 8.2 0 0 1 8 8.37v1.19a3.91 3.91 0 0 0-2-.56 4 4 0 1 0 4 4v-4.63C22.095 6.748 17.622 2.11 12 2ZM6 15a2 2 0 1 1-2 2 2 2 0 0 1 2-2Zm12 4a2 2 0 1 1 2-2 2 2 0 0 1-2 2Z"
            />
        </svg>
    );
};

export const HeadphonesLineOffset: IconOffset = {
    vertical: 8,
    horizontal: 7,
};

export default React.memo(HeadphonesLine);
